import { PanelLeft, Search } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import NotificationBell from '../NotificationBell'

function useHeaderCopy({
    showLeaderboard,
    showProcedures,
    showHistory,
    showScheduler,
    showCalendar,
    showHome,
    showSuggestions,
}) {
    const { t } = useTranslation()
    if (showHome) return { kicker: t('pageHeader.home.kicker'), title: t('pageHeader.home.title'), subtitle: t('pageHeader.home.subtitle') }
    if (showSuggestions) return { kicker: t('pageHeader.suggestions.kicker'), title: t('pageHeader.suggestions.title'), subtitle: t('pageHeader.suggestions.subtitle') }
    if (showLeaderboard) return { kicker: t('pageHeader.leaderboard.kicker'), title: t('pageHeader.leaderboard.title'), subtitle: t('pageHeader.leaderboard.subtitle') }
    if (showProcedures) return { kicker: t('pageHeader.procedures.kicker'), title: t('pageHeader.procedures.title'), subtitle: t('pageHeader.procedures.subtitle') }
    if (showHistory) return { kicker: t('pageHeader.history.kicker'), title: t('pageHeader.history.title'), subtitle: t('pageHeader.history.subtitle') }
    if (showScheduler) return { kicker: t('pageHeader.scheduler.kicker'), title: t('pageHeader.scheduler.title'), subtitle: t('pageHeader.scheduler.subtitle') }
    if (showCalendar) return { kicker: t('pageHeader.calendar.kicker'), title: t('pageHeader.calendar.title'), subtitle: t('pageHeader.calendar.subtitle') }
    return { kicker: t('pageHeader.workspace.kicker'), title: t('pageHeader.workspace.title'), subtitle: '' }
}

export default function AppPageHeader({
    showLeaderboard,
    showProcedures,
    showHistory,
    showScheduler,
    showCalendar,
    showHome,
    showSuggestions,
    onOpenSidebar,
    onOpenCard,
    onOpenGlobalSearch,
}) {
    const { t } = useTranslation()
    const headerCopy = useHeaderCopy({
        showLeaderboard,
        showProcedures,
        showHistory,
        showScheduler,
        showCalendar,
        showHome,
        showSuggestions,
    })

    return (
        <header className="app-header">
            <div className="app-header-main">
                <div className="app-header-title-group">
                    <button
                        type="button"
                        className="app-shell-toggle"
                        onClick={onOpenSidebar}
                        aria-label={t('pageHeader.openMenu')}
                    >
                        <PanelLeft size={18} />
                    </button>

                    <div>
                        <p className="app-header-kicker">{headerCopy.kicker}</p>
                        <h1>{headerCopy.title}</h1>
                        {headerCopy.subtitle ? (
                            <p className="app-header-subtitle">{headerCopy.subtitle}</p>
                        ) : null}
                    </div>
                </div>

                <div className="app-header-actions">
                    <button
                        type="button"
                        className="app-header-btn"
                        onClick={onOpenGlobalSearch}
                        title={t('pageHeader.globalSearch')}
                    >
                        <Search size={16} />
                    </button>

                    <NotificationBell onOpenCard={onOpenCard} />
                </div>
            </div>
        </header>
    )
}
